import React, { useState, useEffect, useMemo } from "react";
import { ISingleBarProps, ICapsuleData } from './type.d';
import { LIUBAI_PERCENT } from './constants';
import { getDataDirectionType } from './util';
import Capsule from "./Capsule";
import Mark from "./Mark";
import { mathFormat } from '@sg/utils/common';
import './index.scss';

export default function SpecialTableBar(props: ISingleBarProps) {
  const { data, height = 40, coefficient = 1 } = props;
  const [pillarsData, setPillarsData] = useState<ICapsuleData[]>([]);
  const [totalPoint, setTotalPoint] = useState<ICapsuleData>({
    title: '',
    value: 0,
    rate: 0,
    type: 'total'
  });

  // 获取分类数据
  const setClassificationData = () => {
    const tmpPillarsData: ICapsuleData[] = [];
    let tmpTotalData: ICapsuleData = {
      title: '',
      value: 0,
      rate: 0,
      type: 'total'
    };
    data?.forEach(item => {
      const newItem = {
        ...item,
        formattedValue: item.value === 0 ? '0' : item.value.toFixed(2),
      };
      if (item.type === 'pillar') {
        tmpPillarsData.push(newItem);
      } else if (item.type === 'total') {
        tmpTotalData = {
          ...newItem,
          liubaiValue: newItem.value * Number(`1.0${LIUBAI_PERCENT}`),
        };
      }
    });
    setPillarsData(tmpPillarsData);
    setTotalPoint(tmpTotalData);
  };

  const dataDirection = useMemo(() => getDataDirectionType(pillarsData, totalPoint), [pillarsData, totalPoint]);

  useEffect(() => {
    setClassificationData();
  }, [data]);

  return (
    <div className="capsule-special-bar" style={{height: `${height || 40}px`}}>
      {
        pillarsData?.length && <div>
          <Capsule
            key={`${pillarsData[0]?.title}_${Math.abs(pillarsData[0]?.value)}_${Math.abs(pillarsData[0]?.value)}`}
            data={pillarsData}
            totalData={totalPoint}
            coefficient={coefficient}
            height={height}
            dataDirection={dataDirection}
            zeroPosition="start"
          />
        </div>
      }
    </div>
  );
}